<t4-list-view #listVw [options]="listOptions" (onItemSelectionChange)="OnItemSelectionChange($event)"  (onDirectSelection)="actionClick('rowclick', $any($event))" (onDataRequest)="onDataRequest($event)">
  <t4-date-time-control [beforeToday]="false" [labelDate]="'CUSTOM.BUTTON.STATE.FORM.FROM-DATE'" [labelTime]="'CUSTOM.BUTTON.STATE.FORM.FROM-TIME'"></t4-date-time-control>

  <ng-container *t4ListActions>
    @if (allowAdd === true && !isInArchiveMode) {
      <button (click)="actionClick('add')" class="btn btn-primary border" type="button"><i class="far fa-plus-square"></i>{{ 'GENERIC.BUTTON.ADDNEW' | translate}}</button>
    }
  </ng-container>

  <ng-container *t4ListItem="let item">

    <td class= "company-info" data-bs-toggle="tooltip" data-bs-placement="bottom" title="{{ item.ExternalId }}">{{ item.CustomerNumber }} / {{item.ExternalId | replaceOnEmpty}}</td>
    <td class= "company-info" data-bs-toggle="tooltip" data-bs-placement="bottom" title="{{ item.Name }}"><t4-customer-identification-control [isIbaActive]="isIbaActive" [customer]="constructCustomerIdentificationModel(item)"></t4-customer-identification-control></td>
    <td class= "company-info" data-bs-toggle="tooltip" data-bs-placement="bottom" title="{{ item.Age }}">{{ showAge(item.Age, item.CustomerType) }}</td>
    @if (isCustomerReworkActive) {
      <td class= "company-info" data-bs-toggle="tooltip" data-bs-placement="bottom" title="{{ item.ParentCompanyName }}">{{ item.ParentCompanyName | replaceOnEmpty }}</td>
      <td class= "company-info">
        @if (item.CustomerType == 1) {
          <span class="badge bg-success">{{ 'BTN.YES' | translate }}</span>
        } @else {
          <span class="badge bg-secondary">{{ 'BTN.NO' | translate }}</span>
        }
      </td>
    } @else {
      <td class= "company-info" data-bs-toggle="tooltip" data-bs-placement="bottom" title="{{ item.Name }}">{{item.CustomerType == 1 ? item.Name : null | replaceOnEmpty }}</td>
    }
    <td class= "company-info" data-bs-toggle="tooltip" data-bs-placement="bottom" title="{{ item.Email }}">{{item.Email}}</td>
    @if (showAddress === true) {
      <td class= "company-info" data-bs-toggle="tooltip" data-bs-placement="bottom" title="{{ getCombinedAddress(item) }}">{{getCombinedAddress(item)}}</td>
    }

    @if (allowEdit) {
      <td class="grid-action">
        @if (!isInArchiveMode) {
          <button (click)="this.actionClick('edit', item)" type="button" class="btn btn-grid btn-round mdi mdi-info mdi-lead-pencil"></button>
        }
        @if (!isInArchiveMode) {
          <button (click)="this.actionClick('delete', item)" type="button" class="btn btn-grid btn-round mdi mdi-danger mdi-trash-can-outline"></button>
        }
      </td>
    }


  </ng-container>

  <ng-container *t4ItemFilter="let kvp=kvp">

    <div class="row">
      <div class="col-lg-10">
        <div class="input-group input-group-sm">
          
            <span class="input-group-text mdi mdi-account-search"></span>
          
          <input type="text" class="form-control form-control-filter me-1 filter-input" placeholder="{{ 'RELATIONS.OVERVIEW.FILTERS.LABEL.SEARCH' | translate }}" (keyup.enter)='listVw.updateFilter($event)' name="query" [(ngModel)]="kvp.query" autocomplete="off">
        </div>
      </div>

      <div class="col-lg-2">

        <div class="form-group">
          <div class="input-group input-group-sm">
            
              <span class="input-group-text mdi mdi-domain"></span>
            
            <input class="form-control form-control-filter me-1 filter-input" placeholder="" [matAutocomplete]="customerTypeSearchAutoComplete" [(ngModel)]="selectedCustomerTypeDisplay" (keyup.enter)='listVw.updateFilter($event)'>
          </div>

          <mat-autocomplete #customerTypeSearchAutoComplete="matAutocomplete" (optionSelected)="onCustomerTypeChange($event.option.value)">
            @for (e of customerTypes; track e) {
              <mat-option  [value]="e">
                {{e.viewValue}}
              </mat-option>
            }
          </mat-autocomplete>

        </div> 
      </div>
    </div>

  </ng-container>

</t4-list-view>
